import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchTreasury, updatePage, updateDecisions, fetchTreasuryBackground } from '../../../redux/treasury'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'
import Treasury from './component'

const anyVersionsChanged = (newTreasury, oldTreasury, deviceId) => {
  let hasChange = false
  if (newTreasury.version !== oldTreasury.version && newTreasury.version > oldTreasury.version && newTreasury.updatedBy && newTreasury.updatedBy !== deviceId) {
    hasChange = true
  }
  return hasChange
}

const checkChange = (fieldName, decisions, lastSynced, changes, apiFieldName) => {
  const newVal = parseInt(decisions[fieldName])
  if (newVal !== lastSynced[fieldName]) {
    changes.push({ [apiFieldName || fieldName]: newVal })
    lastSynced[fieldName] = newVal
  }
}

class TreasuryContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      decisions: null,
      readyForDisplay: false,
      forceRerender: null
    }
    this.lastSynced = {}
  }

  componentDidMount () {
    this.props.fetchTreasury(this.props.teamNumber, this.props.selectedRound)
    this.pollChanges()
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
      this.checkAndUpdate()
      this.lastSynced = {}
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  pollChanges = () => {
    this.interval = setInterval(() => {
      if (this.props.isCurrentTab) {
        this.checkAndUpdate()
        this.props.fetchTreasuryBackground(this.props.teamNumber, this.props.selectedRound)
      }
    }, 5000)
  }

  checkAndUpdate = () => {
    const changes = []
    const decisions = { ...this.state.decisions }

    if (!Object.keys(this.lastSynced).length) {
      return
    }

    // console.log('decisions', decisions)
    // console.log('synced', this.lastSynced)

    checkChange('allOtherAssetsPercentage', decisions, this.lastSynced, changes, 'assetGrowthChange')
    checkChange('depositGrowthChangePercentage', decisions, this.lastSynced, changes, 'depositGrowthChange')
    checkChange('wsfChange', decisions, this.lastSynced, changes)
    checkChange('capitalRatioChange', decisions, this.lastSynced, changes)
    checkChange('wsf1', decisions, this.lastSynced, changes)
    checkChange('wsf2', decisions, this.lastSynced, changes)
    checkChange('wsf3', decisions, this.lastSynced, changes)
    checkChange('wsf4', decisions, this.lastSynced, changes)
    checkChange('wsf5', decisions, this.lastSynced, changes)

    checkChange('homeLoansRisk', decisions, this.lastSynced, changes)
    checkChange('businessLoansRisk', decisions, this.lastSynced, changes)
    checkChange('creditCardsRisk', decisions, this.lastSynced, changes)
    checkChange('institutionalBankingRisk', decisions, this.lastSynced, changes)
    checkChange('offshoreBankRisk', decisions, this.lastSynced, changes)
    checkChange('wealthRisk', decisions, this.lastSynced, changes)
    checkChange('investmentsRisk', decisions, this.lastSynced, changes)
    checkChange('fixedAssetsRisk', decisions, this.lastSynced, changes)
    checkChange('opexRisk', decisions, this.lastSynced, changes)

    checkChange('homeLoansGrowth', decisions, this.lastSynced, changes)
    checkChange('businessLoansGrowth', decisions, this.lastSynced, changes)
    checkChange('creditCardsGrowth', decisions, this.lastSynced, changes)
    checkChange('institutionalBankingGrowth', decisions, this.lastSynced, changes)
    checkChange('offshoreBankGrowth', decisions, this.lastSynced, changes)
    checkChange('wealthGrowth', decisions, this.lastSynced, changes)
    checkChange('investmentsGrowth', decisions, this.lastSynced, changes)
    checkChange('fixedAssetsGrowth', decisions, this.lastSynced, changes)

    checkChange('dividendsReinvested', decisions, this.lastSynced, changes)
    checkChange('groupNpat', decisions, this.lastSynced, changes)
    checkChange('additionalSharesIssued', decisions, this.lastSynced, changes)

    const newdesiredCreditRating = decisions.desiredCreditRating
    if (newdesiredCreditRating !== this.lastSynced.desiredCreditRating) {
      changes.push({ desiredCreditRating: newdesiredCreditRating })
      this.lastSynced.desiredCreditRating = newdesiredCreditRating
    }

    if (changes.length) {
      // console.log(changes)
      this.props.updateDecisions({ team: this.props.teamNumber, round: this.props.selectedRound, decisions: changes, deviceId: this.props.deviceId })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.selectedRound !== prevProps.selectedRound || this.props.roundNumber !== prevProps.roundNumber || this.props.teamNumber !== prevProps.teamNumber) {
      this.lastSynced = {}
      return this.props.fetchTreasury(this.props.teamNumber, this.props.selectedRound)
    }
    const shouldUpdateDecisions =
      (this.props.treasury && !prevProps.treasury) ||
      (this.props.treasury && !prevState.readyForDisplay && !this.state.readyForDisplay) ||
      (this.props.treasury && prevProps.treasury && anyVersionsChanged(this.props.treasury, prevProps.treasury, prevProps.deviceId))

    if (shouldUpdateDecisions) {
      this.lastSynced = {
        allOtherAssetsPercentage: this.props.treasury.allOtherAssetsPercentage,
        depositGrowthChangePercentage: this.props.treasury.depositGrowthChangePercentage,
        wsfChange: this.props.treasury.wsfChange,
        capitalRatioChange: this.props.treasury.capitalRatioChange,
        wsf1: this.props.treasury.wsf1,
        wsf2: this.props.treasury.wsf2,
        wsf3: this.props.treasury.wsf3,
        wsf4: this.props.treasury.wsf4,
        wsf5: this.props.treasury.wsf5,
        homeLoansRisk: this.props.treasury.homeLoansRisk,
        businessLoansRisk: this.props.treasury.businessLoansRisk,
        creditCardsRisk: this.props.treasury.creditCardsRisk,
        institutionalBankingRisk: this.props.treasury.institutionalBankingRisk,
        offshoreBankRisk: this.props.treasury.offshoreBankRisk,
        wealthRisk: this.props.treasury.wealthRisk,
        investmentsRisk: this.props.treasury.investmentsRisk,
        fixedAssetsRisk: this.props.treasury.fixedAssetsRisk,
        opexRisk: this.props.treasury.opexRisk,
        homeLoansGrowth: this.props.treasury.homeLoansGrowth,
        businessLoansGrowth: this.props.treasury.businessLoansGrowth,
        creditCardsGrowth: this.props.treasury.creditCardsGrowth,
        institutionalBankingGrowth: this.props.treasury.institutionalBankingGrowth,
        offshoreBankGrowth: this.props.treasury.offshoreBankGrowth,
        wealthGrowth: this.props.treasury.wealthGrowth,
        investmentsGrowth: this.props.treasury.investmentsGrowth,
        fixedAssetsGrowth: this.props.treasury.fixedAssetsGrowth,
        desiredCreditRating: this.props.treasury.desiredCreditRating,
        dividendsReinvested: this.props.treasury.dividendsReinvested,
        groupNpat: this.props.treasury.groupNpat,
        additionalSharesIssued: this.props.treasury.additionalSharesIssued

      }
      this.setState({
        readyForDisplay: true,
        forceRerender: new Date().valueOf(),
        decisions: {
          allOtherAssetsPercentage: this.props.treasury.allOtherAssetsPercentage,
          depositGrowthChangePercentage: this.props.treasury.depositGrowthChangePercentage,
          wsfChange: this.props.treasury.wsfChange,
          capitalRatioChange: this.props.treasury.capitalRatioChange,
          wsf1: this.props.treasury.wsf1,
          wsf2: this.props.treasury.wsf2,
          wsf3: this.props.treasury.wsf3,
          wsf4: this.props.treasury.wsf4,
          wsf5: this.props.treasury.wsf5,
          homeLoansRisk: this.props.treasury.homeLoansRisk,
          businessLoansRisk: this.props.treasury.businessLoansRisk,
          creditCardsRisk: this.props.treasury.creditCardsRisk,
          institutionalBankingRisk: this.props.treasury.institutionalBankingRisk,
          offshoreBankRisk: this.props.treasury.offshoreBankRisk,
          wealthRisk: this.props.treasury.wealthRisk,
          investmentsRisk: this.props.treasury.investmentsRisk,
          fixedAssetsRisk: this.props.treasury.fixedAssetsRisk,
          opexRisk: this.props.treasury.opexRisk,
          homeLoansGrowth: this.props.treasury.homeLoansGrowth,
          businessLoansGrowth: this.props.treasury.businessLoansGrowth,
          creditCardsGrowth: this.props.treasury.creditCardsGrowth,
          institutionalBankingGrowth: this.props.treasury.institutionalBankingGrowth,
          offshoreBankGrowth: this.props.treasury.offshoreBankGrowth,
          wealthGrowth: this.props.treasury.wealthGrowth,
          investmentsGrowth: this.props.treasury.investmentsGrowth,
          fixedAssetsGrowth: this.props.treasury.fixedAssetsGrowth,
          desiredCreditRating: this.props.treasury.desiredCreditRating,
          dividendsReinvested: this.props.treasury.dividendsReinvested,
          groupNpat: this.props.treasury.groupNpat,
          additionalSharesIssued: this.props.treasury.additionalSharesIssued

        }
      })
    }
  }

  handleChangeValue = (changes) => {
    const actualChanges = { ...changes }
    const forceRerender = actualChanges.forceRerender
    delete actualChanges.forceRerender

    const stateToUpdate = {
      decisions: {
        ...this.state.decisions,
        ...changes
      }
    }

    if (forceRerender) {
      stateToUpdate.forceRerender = forceRerender
    }
    this.setState(stateToUpdate)
  }

  render () {
    if (this.props.isLoading || !this.state.readyForDisplay) {
      return <CenteredSpinner />
    }
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }
    if (!this.props.treasury) {
      return <InlineError message={`No treasury data have been uploaded for round ${this.props.selectedRound}`} />
    }
    return (
      <Treasury
        treasury={this.props.treasury}
        selectedRound={this.props.selectedRound}
        decisions={this.state.decisions}
        onChangeValue={this.handleChangeValue}
        currentPage={this.props.currentPage}
        updatePage={this.props.updatePage}
        enableChanges={this.props.enableChanges}
        forceRerender={this.state.forceRerender}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'Treasury',
  currentPage: state.treasury.currentPage,
  enableChanges: state.game.selectedRound === state.game.currentRound,
  teamNumber: state.team.id,
  selectedRound: state.game.selectedRound,
  deviceId: state.device.deviceId,
  roundNumber: state.game.currentRound,
  isLoading: state.treasury.isLoading,
  isLoaded: state.treasury.isLoaded,
  error: state.treasury.error,
  treasury: state.treasury.treasury
})

export default connect(mapStateToProps, {
  fetchTreasury,
  updatePage,
  fetchTreasuryBackground,
  updateDecisions
})(TreasuryContainer)
